<template>
  <VMenu
    rounded="4"
    offset-y
  >
    <template #activator="{ on, attrs }">
      <VBtn
        v-click-outside="switchState"
        v-blur
        light
        data-test="langSwitcher"
        color="white"
        class="mx-2 shadow-none"
        v-bind="attrs"
        v-on="on"
        @click.stop="isLangSwitcherShow = !isLangSwitcherShow"
      >
        <VImg
          class="lang-img"
          :src="require(`@slg/web-customer-shared/src/assets/img/flag-${currentLang}.svg`)"
          :alt="$t('imageAlt.languageFlag', { language: currentLangName })"
        />
        <span class="lang-name body-1 ml-2 mr-1">{{ currentLangName }}</span>
        <VIcon>
          {{ isLangSwitcherShow ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</VIcon>
      </VBtn>
    </template>
    <VList
      nav
      dense
      class="py-2 px-1"
    >
      <VListItem
        v-for="(item, index) in languages"
        :key="index"
        class="list-item"
        :class="{'selected-item': currentLang === item.value}"
        :data-test="`langSwitcherItem-${item.value}`"
        dense
        @click="setLang(item.value)"
      >
        <slot name="customLanguage">
          <VListItemTitle class="body-1 lang">
            <VListItemIcon class="mr-3">
              <VImg
                class="lang-img"
                :src="require(`@slg/web-customer-shared/src/assets/img/flag-${item.value}.svg`)"
                :alt="$t('imageAlt.languageFlag', { language: item.text })"
              />
            </VListItemIcon>
            <VListItemContent>
              {{ item.text }}</VListItemContent>
          </VListItemTitle>
        </slot>
      </VListItem>
    </VList>
  </VMenu>
</template>
<script lang="ts">
export default {
  name: 'TheLanguageSwitcher',
};
</script>

<script setup lang="ts">
import { computed, ref } from 'vue';

const props = defineProps({
  currentLang: {
    type: String,
    default: null,
  },
  languages: {
    type: Array,
    default: () => [],
    required: false,
  },
});

const emit = defineEmits(['setLang']);

const isLangSwitcherShow = ref(false);

const currentLangName = computed(() => {
  const match = (props.languages as any[]).find(({ value }) => value === props.currentLang);
  if (match?.text) {
    return match.text;
  }
  return props.currentLang ? String(props.currentLang) : '';
});

function setLang(lang: any) {
  if (lang !== props.currentLang) {
    emit('setLang', lang);
  }
}

function switchState() {
  if (isLangSwitcherShow.value) {
    isLangSwitcherShow.value = !isLangSwitcherShow.value;
  }
}
</script>

<style scoped lang="scss">
@import "@slg/web-customer-shared/src/style/headerLinks.scss";

.selected-item {
  background-color: var(--v-pageBg-base) !important;
}
.list-item {
  width: 142px;
  height: 48px;

  .lang {
    display: flex;
  }
}

.lang-img {
  width: 24px;
  height: 24px;
  border-radius: 12px;
}

.lang-name {
  max-width: 9rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-transform: none;
}
</style>
